// 工作计划
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行-项目概况 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>项目概况</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.project_overview"
        placeholder="请输入项目概况"
        :autosize="{minRows: 3}"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第三行--拟选用评价依据 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icon_yiju@2x.png" alt />
        <span>拟选用评价依据</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.evaluation_basis"
        :autosize="{minRows: 3}"
        placeholder="请输入拟选用评价依据"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第四行--确定评价范围 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:14px" src="../../assets/image/icon_fw@2x.png" alt />
        <span>确定评价范围</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.evaluation_scope"
        :autosize="{minRows: 3}"
        placeholder="请输入评价范围"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第五行--危险源辨识、评价单元划分 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icon_huaf@2x.png" alt />
        <span>危险源辨识、评价单元划分</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.unit_division"
        :autosize="{minRows: 3}"
        placeholder="请输入单元划分情况"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第六行--应重点关注的安全问题 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icon_zhongd@2x.png" alt />
        <span>应重点关注的安全问题</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.safety_problem"
        placeholder="请输入应重点关注的安全问题"
        :autosize="{minRows: 3}"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第七行-评价任务时间安排 -->
    <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:200px">
        <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
        <span style="widthL:150px">评价任务时间安排</span>
      </div>
      <div class="rightInput">
        <el-button class="AddUser" v-if="isSubmit" @click="handleAddTM">添加安排</el-button>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="workInfo"
          label="工作内容"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.workInfo}}</span>
            <span v-else>{{scope.row.workInfo}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="startTime"
          label="开始时间"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.startTime}}</span>
            <span v-else>{{scope.row.startTime}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="endTime" label="完成时间">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.endTime}}</span>
            <span v-else>{{scope.row.endTime}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <span
              v-if="isSubmit"
              @click.prevent="removeUser(scope.$index,scope.row)"
              style="cursor: pointer;color:#128BF1"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 上传 -->
    <div class="oneRow" type="min-height:60px">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <!-- 上传 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">*请上传安全评价工作计划,模板文件：</div>
        <a style="font-size:14px;" href="http://control.sxpz.vip/Template/安全评价工作计划.doc">安全评价工作计划.doc</a>
      </div>
    </div>
    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>
    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->

    <!-- 项目评价书-评价组成员添加弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      @close="handleClosedAdd"
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加成员</span>
      </div>
      <div class="diaContainer">
        <!-- 新增系统公告表单 -->
        <el-form ref="form" :model="AddUserForm" label-width="30%">
          <el-form-item label="工作内容">
            <el-input :placeholder="isSubmit ? '请输入工作内容' : ''" v-model="AddUserForm.workInfo"></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              :disabled="!isSubmit"
              value-format="yyyy-MM-dd"
              v-model="AddUserForm.startTime"
              type="date"
              :picker-options="pickerOptionsStart"
              :placeholder="isSubmit ? '选择日期' : ''"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="完成时间">
            <el-date-picker
              :disabled="!isSubmit"
              value-format="yyyy-MM-dd"
              v-model="AddUserForm.endTime"
              :picker-options="pickerOptionsEnd"
              type="date"
              :placeholder="isSubmit ? '选择日期' : ''"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" v-if="diaFormType=='add'" @click="handleAddUser">添 加</el-button>
        <el-button type="primary" v-if="diaFormType=='edit'" @click="editUserForm">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'15'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import UploadFile from '../UploadFile'

export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      detailsImgList: [],
      submitImgList: [],
      diaFormType: 'add',
      editTableIndex: '',

      dialogVisibleAdd: false,
      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      AddUserForm: {
        workInfo: '',
        startTime: '',
        endTime: '',
      },
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      projectTypeList: [],
      projectPjList: [],
      addFormData: {
        annex: '',
        // project_overview: '',
        // evaluation_basis: '',
        // evaluation_scope: '',
        // unit_division: '',
        // safety_problem: '',
        schedule: '',
      },
      infop: '',
      value: '',
      options: [
        {
          value: '选项1',
          label: '黄金糕',
        },
      ],
      tableData: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.AddUserForm.endTime) {
            return time.getTime() > new Date(this.AddUserForm.endTime).getTime()
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.AddUserForm.startTime) {
            return (
              time.getTime() <
              new Date(this.AddUserForm.startTime).getTime() - 86400000
            )
          }
        },
      },
      isComponentsShow: false,
    }
  },

  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    editUserForm() {
      this.tableData[this.editTableIndex] = this.AddUserForm
      // 提交修改的那个
      console.log('提交修改this.AddUserForm', this.AddUserForm)
      this.dialogVisibleAdd = false
    },
    handleAddTM() {
      this.diaFormType = 'add'
      this.dialogVisibleAdd = true
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddUserForm = row
      console.log('this.AddUserForm', this.AddUserForm)
      console.log('点击了哪一行', this.AddUserForm)
      this.dialogVisibleAdd = true
    },
    // 添加成员
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        workInfo: this.AddUserForm.workInfo,
        startTime: this.AddUserForm.startTime,
        endTime: this.AddUserForm.endTime,
      })
      this.dialogVisibleAdd = false
    },
    // 删除成员
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },

    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/scheme_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.schedule = JSON.stringify(this.tableData)

      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('annex', JSON.stringify(this.submitImgList))
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)
        // param.append('project_overview', this.addFormData.project_overview)
        // param.append('evaluation_basis', this.addFormData.evaluation_basis)
        // param.append('evaluation_scope', this.addFormData.evaluation_scope)
        // param.append('unit_division', this.addFormData.unit_division)
        // param.append('safety_problem', this.addFormData.safety_problem)
        param.append('schedule', this.addFormData.schedule)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/scheme',
          data: param,
        })
        if (res.code != 200) {
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *立项-项目分配-获取项目详情(当有projectid时)
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/scheme_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 如果有项目名称
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }

      this.S_project_name = res.datas.info.project_name
      // 判断表格
      if (this.addFormData.schedule) {
        this.tableData = this.addFormData.schedule
      }
      // 处理文件
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      this.isComponentsShow = true
      console.log('项目计划方案-详情', this.addFormData)
    },
    handleCloseAdd() {
      this.dialogVisibleAdd = false
    },
    handleClosedAdd() {
      this.AddUserForm = {
        workInfo: '',
        startTime: '',
        endTime: '',
      }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    ProjectFlow,
    UploadFile,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(./projectForm.less);
</style>